import { Theme, Components } from '@mui/material/styles';
import scssVariables from '@styles/variables.module.scss';

import { Icon } from '@/components/ui/Icon';
import { IconProps } from '@/components/ui/Icon';

export const MuiDatePicker: Components<Theme>['MuiDatePicker'] = {
  defaultProps: {
    slotProps: {
      openPickerButton: {
        size: 'small',
      },
    },
    slots: {
      openPickerIcon: (props: IconProps) =>
        Icon({ ...props, name: 'event', color: scssVariables.ColorBlack60 }),
      rightArrowIcon: (props: IconProps) =>
        Icon({
          ...props,
          name: 'keyboard_arrow_right',
          size: 'large',
          color: scssVariables.ColorBlack60,
        }),
      leftArrowIcon: (props: IconProps) =>
        Icon({
          ...props,
          name: 'keyboard_arrow_left',
          size: 'large',
          color: scssVariables.ColorBlack60,
        }),
    },
  },
};
